module.exports = __webpack_public_path__ + "img/vegetable-nopales-350x184.897b7557.jpg";